// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"97ef8972","866":"cf302bf3"}[chunkId] + ".chunk.css";
};